module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAA7klEQVQokZWSvWoCQRRGzy6rIhZhW21SbSXGH7AQBCtBYmFjoTZWxhew9Dm0T0CsXXvBFzBBEKxsUgdBGw2s3GV2WX/B08x8dziXucxou1oYhWy6QANIqtoSGAFD4CAFT0gANpDmNgugCvzqqrOtmVY60pugmZZvhNoD9FQd1WgKRET4cAsvcYxCGVl9oVhFt3JefAM6IjTvXOMWTQPIBg+i/c9AiF06GUPN4HOc2zi7rRvDldalcBThjP/ZGGczuycsZYZnGMk7OJ6hvZb87m42LZy/tRd/gPyZ8IBv4F0e7mqGAHtgBXwBA/drACeWHjOsGiGbYQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/imgs/PCimg/hoticon.png
// module id = H6Ro
// module chunks = 41